import { ReduxState } from 'src/store/types';
import { stringToSelectItem } from 'src/utils/select/stringToSelectItem';

export const virtualGraphItemsSelector =
  (databaseId?: string) => (state: ReduxState) =>
    Object.values(state.dataSources.virtualGraphsById)
      .sort()
      .filter(
        ({ database }) =>
          !databaseId || database === '*' || database === databaseId
      )
      .map(({ name }) => stringToSelectItem(name));
